<ion-button (click)="getcontacts()">TEST</ion-button>

